<template>
	<div :class="{'container-fluid bg-white':!isSubComponent}">
		<contact-toolbar v-if="!isSubComponent" heading="Sub-Contacts">
			<template slot="main">
				<div>
					<router-link :to="'/contact/new/details/'+$route.params.id" class="btn btn-success" v-on:click="newSubcontact">
						<i class="fa fa-plus"></i>
						New Sub-Contact
					</router-link>
				</div>
			</template>
		</contact-toolbar>

		<div v-else class="d-flex flex-row justify-content-between">
			<h3 class="mb-0">Sub-Contacts</h3>

			<div>
				<router-link :to="'/contact/new/details/'+$route.params.id" class="btn btn-success" v-on:click="newSubcontact">
					<i class="fa fa-plus"></i>
					New Sub-Contact
				</router-link>
			</div>
		</div>

		<table-list
			:records="$store.contact.SubContacts"
			:fields="subContactFields"
			record-name="Sub-Contact"
			has-edit="/contact/{?}/details"
			:hide-record-count="true"
			id-field="slug">
		</table-list>
	</div>
</template>

<script>
import ContactToolbar from "./ContactToolbar"
import ContactMixins from "@/mixins/ContactMixins"
import TableList from "@/components/TableList"

export default {

	name: 'ContactSubContacts',
	components: {
		ContactToolbar,
		TableList
	},
	mixins:[ContactMixins],
	props: ["isSubComponent"],
	data() {
		return {
			subContactFields: [
				{
					label: "Name",
					key: "name"
				},
				{
					label: "Phone",
					key: "phone"
				},
				{
					label: "Email",
					key: "email"
				},
				{
					label: "Position",
					key: "position"
				},
				{
					label: "Address",
					key: "address",
					showOnMobile: false
				}
			],
		}
	},
	watch: {
		'$store.contact'() {
			//if (!("Contact" in this.$store.contact) || this.$route.params.id != this.$store.contact.slug)
				//this.fetchData()
		}
	},
	methods: {
		newSubcontact() {

		},
		fetchData() {
			let vm = this

			this.spinner(true)

			let promises = [
				this.fetchContact(this.$route.params.id,["Contact","User","Company",{model:"ContactFile", fields:[]}])
			]

			Promise.all(promises).then(responses => {
				vm.spinner(false)
			})
		}
	},
	created() {
		if (!("Contact" in this.$store.contact) || this.$route.params.id != this.$store.contact.slug)
			this.fetchData()
	}

}
</script>

